import React from 'react';
import { Cell } from 'styled-css-grid';

import { INotificationDetailsRowProps } from '../notification-actions/types';

export const DetailsRow: React.FC<INotificationDetailsRowProps> = ({
  label,
  value,
  component,
}) => (
  <>
    <Cell>
      <strong>{label}</strong>
    </Cell>
    <Cell>{component || value}</Cell>
  </>
);
